import { BrowserLogger, WorkerLogger } from '@ciaopeople/cp-shatsu/Logging';

export const MessagingWorkerLogger = new WorkerLogger("[SDK/MSG-Worker]");
export const MessagingPushNotHelperLogger = new BrowserLogger("[SDK/MSG-PushNot]", "#0000FF");
export const ABTestLogger = new BrowserLogger("[SDK/AB-Test]", "#FF0000");

export const LoginManagerLogger = new BrowserLogger("[Login-MGR]", "#777777");

export const GA4StatsLogger = new BrowserLogger("[GA4-Stats]", "#873787");

export const AggregateStatsLogger = new BrowserLogger("[GAU-Stats]", "#000000");

// export const SDKLogger = new BrowserLogger("[SDK]", "#FF0000");